var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsFlag = function SvgUsFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#us-flag_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "us-flag_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#us-flag_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5 0h29.942v19.961H-5V0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 2.495h29.942V4.99H-5V2.495Zm0 4.99h29.942V9.98H-5V7.485Zm0 4.99h29.942v2.495H-5v-2.495Zm0 4.99h29.942v2.496H-5v-2.495Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 0H9.97v10.748H-5V0Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.838 4.403-.242.742h-.78l.632.458-.242.742.632-.458.63.458-.24-.742.63-.458h-.78l-.24-.742Zm.24 3.419-.24-.742-.242.742h-.78l.632.458-.242.742.632-.459.63.459-.24-.742.63-.458h-.78Zm-3.296 0-.24-.742-.242.742h-.78l.632.458-.242.742.631-.459.631.459-.24-.742.63-.458h-.78Zm-.24-3.419-.242.742h-.78l.632.458-.242.742.631-.458.631.458-.24-.742.63-.458h-.78l-.24-.742ZM.837 1.726l-.242.742h-.78l.632.458-.242.742.632-.458.63.458-.24-.742.63-.458h-.78l-.24-.742Zm-3.296 0-.242.742h-.78l.632.458-.242.742.631-.458.631.458-.24-.742.63-.458h-.78l-.24-.742Zm6.591 2.677-.24.742h-.78l.63.458-.24.742.63-.458.631.458-.24-.742.63-.458h-.78l-.24-.742Zm.241 3.419-.24-.742-.242.742h-.78l.632.458-.241.742.63-.459.631.459-.24-.742.63-.458h-.78Zm3.296 0-.24-.742-.242.742h-.78l.632.458-.241.742.63-.459.631.459-.24-.742.63-.458h-.78Zm-.24-3.419-.242.742h-.78l.632.458-.241.742.63-.458.631.458-.24-.742.63-.458h-.78l-.24-.742ZM4.133 1.726l-.24.742h-.78l.63.458-.24.742.63-.458.631.458-.24-.742.63-.458h-.78l-.24-.742Zm3.297 0-.242.742h-.78l.632.458-.241.742.63-.458.631.458-.24-.742.63-.458h-.78l-.24-.742Z",
    fill: "#F0F0F0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "us-flag_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgUsFlag;